import { Body, H5, H4, Small } from "@/components/standard/BFText"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { View } from "react-native"
import UtilityRehab from "phosphor-react-native/src/icons/HardHat"
import { BFLink } from "@/components/buttons/Links"
import { displayCurrency } from "@/utils/NumberUtils"
import { BFColors } from "@/constants/Colors"
import { useIsDesktop } from "@/hooks/useIsDesktop"
import { useRehabBudgetingFeature } from "@/hooks/features/useRehabBudgetingFeature"
import { useLoanContext } from "@/screens/loans/components/LoanContext"
import { loanRehabBudget } from "@/screens/loans/utils/LoanUtils"
import {
  type BudgetReviewStatus,
  getRehabTextForStatus,
} from "@/screens/rehab/utils/Rehab"

export const LoanRehabSection = ({ loanId }: { loanId: string }) => {
  const isDesktop = useIsDesktop()
  const { loanApplication } = useLoanContext()
  const { rehabBudget, featureIsEnabled } = useRehabBudgetingFeature(
    loanApplication,
    isDesktop
  )

  if (!rehabBudget || !featureIsEnabled || !rehabBudget.totalBudget) {
    return null
  }

  return (
    <Vertical className={"gap-1.5 flex-1"}>
      <Horizontal className="justify-between">
        <H4 color={"default"}>Rehab SOW</H4>
        <BFLink
          testId="rehab-sow-loan-more-details"
          path={loanRehabBudget(loanApplication.id)}
          text={<Small>More Details</Small>}
          size="sm"
        />
      </Horizontal>
      <View
        style={{
          backgroundColor: BFColors.lightest,
          borderColor: BFColors.lightGrey,
          borderWidth: 1,
          borderRadius: 4,
          padding: 20,
          overflow: "hidden",
        }}
      >
        <Horizontal className="justify-start flex-1 gap-3">
          <View className="p-0.5 my-auto">
            <UtilityRehab size={24} />
          </View>
          <Vertical className="flex-1">
            <Horizontal className="gap-1">
              <H5>Status:</H5>
              <H5 className={`text-mustard-yellow`}>
                {rehabBudget.status
                  ? getRehabTextForStatus(
                      rehabBudget.status as BudgetReviewStatus
                    )
                  : ""}
              </H5>
            </Horizontal>
            <Body className="text-dark-grey">
              Your current budget is{" "}
              {displayCurrency({
                value: Number(rehabBudget.totalBudget || "0") || 0,
              })}
            </Body>
          </Vertical>
        </Horizontal>
      </View>
    </Vertical>
  )
}
